import React, { useState } from 'react';
import './footer.scss';
import Links from 'constants/links';
import clsx from 'clsx';
import TermsOfUse from 'components/terms-of-use/terms-of-use';
import { Anchor, Button, useModal } from '@ampol/design-system';
import { useSelector } from 'react-redux';
import { trackCustomEvent } from 'utilities/app-insights';

const Footer = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const loggedInUser = useSelector((state) => state.userStore.loggedInUser);

  const handleOpenModal = () => {
    trackCustomEvent('Terms of Use', loggedInUser, undefined, 'Clicked on Terms of Use to open Terms of Use Modal.');
    setIsModalOpen(true);
    detailModal.open();
  };

  const handlePrivacyClick = () => {
    trackCustomEvent('Privacy', loggedInUser, undefined, 'Clicked on Privacy to open Privacy page.');
  };

  const detailModal = useModal({
    id: 'termsOfUse',
    title: 'Terms of Use',
    content: <TermsOfUse />,
    variant: 'triple',
    color: 'blue',
    actions: [{
      label: 'Close',
      onClick: () => detailModal.close(),
    }],
    onClose: () => setIsModalOpen(false),
  });

  return <footer className='footer'>
    <ul className="footer__nav">
      <li className={clsx('footer__nav-item',{ 'footer__nav-item--active': isModalOpen })}>
        <Button 
          label="Terms of Use"
          variant="primary"
          color="blue"
          onClick={() => handleOpenModal()}
        />
      </li>
      <li className='footer__nav-item'><Anchor href={Links.PRIVACY} className='footer__nav-link' onClick={handlePrivacyClick}>Privacy</Anchor></li>
    </ul>
  </footer>;
};

export default Footer;
